// extracted by mini-css-extract-plugin
export default {"nav":"navHeader_nav__3qfxr","navImage":"navHeader_navImage__acbQS","userName":"navHeader_userName__leYI9","menuButton":"navHeader_menuButton__oQ35h"};